import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  return <AnimatePresence data-id="element-191">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-ink-dark/40 z-50 backdrop-blur-sm" data-id="element-192" />
          <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg bg-white p-8 rounded-sm shadow-2xl z-50 max-h-[80vh] overflow-y-auto border border-gold/20" data-id="element-193">
            <div className="flex justify-between items-center mb-6" data-id="element-194">
              <h2 className="text-3xl font-serif text-ink-dark" data-id="element-195">{title}</h2>
              <button onClick={onClose} className="text-ink-light hover:text-ink-dark transition-colors" aria-label="Cerrar" data-id="element-196">
                <X size={24} data-id="element-197" />
              </button>
            </div>
            <div className="prose prose-sm text-ink-light font-sans space-y-4" data-id="element-198">
              {children}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}
export function TermsModal({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Términos y Condiciones" data-id="element-199">
      <p data-id="element-200">
        Al reservar una cita con Pestañas Ingri, aceptas los siguientes términos
        y condiciones.
      </p>
      <h3 className="text-xl font-serif text-ink mt-4 mb-2" data-id="element-201">
        Política de Cancelación
      </h3>
      <p data-id="element-202">
        Requerimos un aviso de al menos 24 horas para cancelar o reprogramar su
        cita. Las cancelaciones tardías o ausencias pueden estar sujetas a un
        cargo.
      </p>
      <h3 className="text-xl font-serif text-ink mt-4 mb-2" data-id="element-203">
        Llegadas Tardías
      </h3>
      <p data-id="element-204">
        Si llega más de 15 minutos tarde, es posible que debamos reprogramar su
        cita para no afectar a los siguientes clientes.
      </p>
      <h3 className="text-xl font-serif text-ink mt-4 mb-2" data-id="element-205">
        Garantía de Satisfacción
      </h3>
      <p data-id="element-206">
        Si tiene algún problema con su servicio, contáctenos dentro de las
        primeras 48 horas para que podamos evaluarlo y ofrecer una solución.
      </p>
    </Modal>;
}
export function PrivacyModal({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Política de Privacidad" data-id="element-207">
      <p data-id="element-208">
        En Pestañas Ingri, respetamos su privacidad y nos comprometemos a
        proteger sus datos personales.
      </p>
      <h3 className="text-xl font-serif text-ink mt-4 mb-2" data-id="element-209">
        Recopilación de Información
      </h3>
      <p data-id="element-210">
        Recopilamos información básica de contacto (nombre, teléfono, correo
        electrónico) únicamente con el propósito de gestionar sus citas y
        comunicarnos con usted sobre nuestros servicios.
      </p>
      <h3 className="text-xl font-serif text-ink mt-4 mb-2" data-id="element-211">
        Uso de la Información
      </h3>
      <p data-id="element-212">
        Sus datos no serán compartidos, vendidos ni alquilados a terceros. Solo
        los utilizamos para brindarle el mejor servicio posible.
      </p>
      <h3 className="text-xl font-serif text-ink mt-4 mb-2" data-id="element-213">Fotografías</h3>
      <p data-id="element-214">
        Podemos solicitar tomar fotografías de sus ojos para nuestro portafolio.
        Siempre pediremos su consentimiento explícito antes de publicar
        cualquier imagen en nuestras redes sociales o sitio web.
      </p>
    </Modal>;
}